import Parse from 'html-react-parser';

function BMP20142(props) {
    let svgCode =
    `<svg width="56" height="264" viewBox="0 0 56 264" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect y="176" width="54" height="84" fill="${props.darkFill}"/>
    <g fill="${props.fontColour}" stroke="${props.fontColour}">
        <line x1="27" y1="188" x2="27" y2="208.25" stroke-width="2"/>
        <line x1="37.625" y1="198.812" x2="17.375" y2="198.812" stroke-width="2"/>
        <path d="M14 199L20 193.804L20 204.196L14 199Z" />
        <path d="M27 186L32.1962 192H21.8038L27 186Z" />
        <path d="M40 199L34 204.196V193.804L40 199Z" />
        <path d="M27 212L21.8038 206H32.1962L27 212Z" />
    </g>
    </svg>`

    props.svgReturn(70, svgCode, "bmp00142", 56, 264);

    const style = {
        position: "absolute",
        overflow: "hidden",
        height: "264px",
        top: "645px",
        left: "92px",
        display: props.display
    }

    const inStyle = {
        marginTop: "0px"
    }

    return (
        <div style={style}>
            <div style={inStyle}>
            {Parse(svgCode)}
            </div>
        </div>
    );
}

export default BMP20142;